import currency from "currency.js";

export default function (value) {
  return currency(value, { symbol: "$", precision: 2 }).format();
}
